import * as React from 'react';
import { Outlet , useNavigate} from 'react-router-dom';

import LogoutIcon from '@mui/icons-material/Logout';
import { 
    Box,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Button
 } from '@mui/material';

import { CONST, TokenValidator, TS_CONSTS } from '../../utils';
import { Confirmation } from '../utils';
import NavigationActions from '../navigationActions';
import { TrackingNavigationProvider, useTrackingNavigation } from '../trackingNavigation';

export default function Holder() {
    return <TrackingNavigationProvider><TrackingHolder /></TrackingNavigationProvider>;
}
function TrackingHolder() {
    const tracking = useTrackingNavigation();
    const nav = useNavigate();

    const [logoutUi, showUi] = React.useState(false);
    const [loged, isLoged] = React.useState(false);
    const [area, hasArea] = React.useState(false);

    React.useEffect(() => {
        handleLoading();
    },[]);

    const handleLoading = async() => {
        checkLogin();
        checkArea();
    }

    const checkLogin = async() => {
        const user = await TokenValidator.GetStaffUser();

        if(user === null){
            return;
        }

        if(await !TokenValidator.ValidTokenDate(user)){
            return;
        }

        isLoged(true);
    }
    
    const checkArea = async() => {
        const result = JSON.parse(localStorage.getItem(CONST.STORAGE_KEYS.TS_AREA));

        if(result === null){
            return;
        }

        hasArea(true);
    }

    const logout = async() => {
        if (tracking.isBusy()) return;
        CONST.TS_LOGOUT_KEYS.forEach(x => {
            localStorage.removeItem(x);
        })
        showUi(false);
        isLoged(false);
        hasArea(false);
        nav('', {replace: true});
    }   

    const LoginContext = {
        Confirmation : isLoged
    }

    const MainContext = {
        Confirmation : hasArea,
        HasArea : area
    }

    const outletContext = {
        Login : LoginContext,
        Main  : MainContext
    }

    return(
        <Box>
            <AppBar 
                position="static"
            >
                <Toolbar
                    sx={{
                        gap: 2
                    }}
                >
                <NavigationActions />

                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    TRACKING STATIONS
                </Typography>
                {area && (
                    <Button
                        variant='contained'
                        size='small'
                        disabled={tracking.busy}
                        onClick={() => {if (!tracking.isBusy()) hasArea(false);}}
                    >
                        Change Station Area
                    </Button>
                )}

                {loged && (
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        disabled={tracking.busy}
                        onClick={() => {if (!tracking.isBusy()) showUi(true);}}
                    >
                        <LogoutIcon />
                    </IconButton>
                )}

                
                </Toolbar>
            </AppBar>
            
            <Confirmation 
                open={logoutUi} 
                onClose={() => showUi(false)} 
                onConfirm={logout} 
                title={'Log Out'} 
                msg={'Please, confirm to logout from Track Station'}
            />

            <Outlet context={outletContext}/>
        </Box>
    );
}
